import workspaceQuery from '../../../graphql/queries/sales/PaymentMethodsWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/sales/PaymentMethodsListQuery.graphql';
import instanceQuery from '../../../graphql/queries/sales/PaymentMethodsQuery.graphql';
import defaultQuery from '../../../graphql/queries/sales/PaymentMethodsDefault.graphql';
import mutationQuery from '../../../graphql/mutations/sales/PaymentMethodsMutation.graphql';
import fragment from '../../../graphql/fragments/sales/PaymentMethodsFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';
import { FilterOperation, PaymentType } from '../../../graphql/schema/p4types';

const PaymentMethod: EntityType = {
  type: 'PaymentMethod',
  title: 'Payment Methods',
  formTitle: 'Payment Method',
  formUrl: '/Sales/PaymentMethod/Details/',
  workspaceUrl: '/Sales/PaymentMethod/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'description',
    remoteFilter: true,
    preLoad: true,
    predefinedFilters: [
      {
        filterOperation: FilterOperation.NotEquals,
        filterParameters: { field: 'paymentType', value: PaymentType.CreditNote },
      },
    ],
  },
  fragment,
  screenReference: 'SALES_PAYMENT_METHODS',
};

export default PaymentMethod;
